import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../../../../css/wallet/History/DepositsAndWithdrawalsHistory.css";
import { withdrawalsHistoryRequest } from "./WithdrawalsHistoryRequest";
import HistoryLoading1 from "../HistoryLoading1";

function WithdrawalsHistory({ theme }) {
  const [requestStatus, setRequestStatus] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    withdrawalsHistoryRequest(setRequestStatus, setData);
  }, []);

  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <>
      {requestStatus ? (
        <HistoryLoading1 theme={theme}></HistoryLoading1>
      ) : data.length > 0 ? (
        <div className="historyItemsDiv">
          {data.map((item, index) => {
            return (
              <div
                className={`historyItemDiv ${theme}`}
                onClick={() => {
                  navigate("/transaction/" + item.link);
                }}
              >
                <div className={`historyItemIconDiv ${theme}`}>
                  <img src="/icons/withdrawal.png"></img>
                </div>

                <div className="historyItemInfoDiv">
                  <div className="derrtgref">
                    <div>{item.amount.toLocaleString("en-US")}</div>
                    <div className="kfjjek3xf">
                      {t("fee") + " " + item.fee.toLocaleString("en-US")}
                    </div>
                  </div>

                  <div className="derrtgref">
                    <div>{item.status}</div>
                    <div className="kfjjek3xf">{item.shamsi_date}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="emptyDiv">
          <img src="/images/empty512.png"></img>
          <div className="emptyTitleDiv">{t("Empty")}</div>
        </div>
      )}
    </>
  );
}

export default WithdrawalsHistory;
